import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

//Import components
import Layouts from './components/layouts'
import Pages from "./components/pages"


const ClientRoutes = () => (
    <Router>
        <Switch>
            <Layouts.External path="/verify/:verifiedEmail" component={Pages.PageVerifyEmail} />
            <Layouts.External exact path="/login" component={Pages.PageLogin} />
            <Layouts.External path="/teacher-signup" component={Pages.PageTeacherSignup} />
            <Layouts.InternalTeacher path="/teacher/home" component={Pages.PageTeacherHome} />
            <Layouts.InternalTeacher exact path="/create-virtual-class" component={Pages.PageCreateVirtualClass} />
            <Layouts.InternalTeacher path="/teacher/:classId/create-class-plan"
                component={Pages.PageInitializeClassPlan} />
            <Layouts.InternalTeacher path="/create-virtual-class/:classId/edit"
                component={Pages.PageCreateVirtualClass} />
            <Layouts.InternalTeacher exact path="/class/:classId" component={Pages.PageClassInfo} />
            <Layouts.InternalTeacher exact path="/class/:classId/add-students" component={Pages.PageAddStudentToClass} />
            <Layouts.InternalTeacher exact path="/class/:classId/edit-students"
                component={Pages.PageAddStudentToClass} />
            <Layouts.InternalTeacher exact path="/teacher/:sid/edit-teacher-profile"
                component={Pages.PageEditTeacherProfile} />
            <Layouts.InternalTeacher path="/class/:classId/adding-content" component={Pages.PageAddingContent} />
            <Layouts.InternalTeacher path="/class/:classId/adding-assignment" component={Pages.PageAddingAssignment} />
            <Layouts.InternalTeacher path="/class/:classId/adding-question" component={Pages.PageAddingQuestion} />
            <Layouts.InternalTeacher exact path="/class/:classId/class-plan/:ClassPanID"
                component={Pages.PageCreateClassPlan} />
            <Layouts.InternalTeacher path="/class/:classId/invite-students" component={Pages.PageStudentInvite} />
            <Layouts.InternalTeacher path="/teacher/start-live-class" component={Pages.PageStartLiveClass} />
            <Layouts.InternalStudent path="/student/start-live-class" component={Pages.PageStartLiveClass} />
            <Layouts.InternalStudent path="/student/:sid/edit-student-profile"
                component={Pages.PageEditStudentProfile} />
            <Layouts.InternalTeacherDashboard exact path="/teacher/dashboard/:classId" component={Pages.TeachersDashboard} />
            <Layouts.InternalTeacherDashboard exact path="/teacher/dashboard/:classId/attendance" component={Pages.TeachersAttendance} />
            <Layouts.InternalTeacherDashboard exact path="/teacher/dashboard/:classId/doubts" component={Pages.TeachersDoubts} />
            <Layouts.External path="/student/complete-profile" component={Pages.PageStudentCompleteProfile} />
            <Layouts.External path="/teacher/complete-profile" component={Pages.PageTeacherCompleteProfile} />
            <Layouts.External path="/student/upcoming-class" component={Pages.PageStudentUpcomingClass} />
            <Layouts.External path="/accept-invitation" component={Pages.PageStudentAcceptInvite} />
            <Layouts.External exact path="/" component={Pages.PageLogin} />
            <Route path="*" component={Pages.PagePageNotFound} />
        </Switch>
    </Router>
)

export default ClientRoutes
